import { extend as _rawExtend } from 'flarum/common/extend';
export default () => {
  // (辉哥 9/17 16:47 派 Coder 修): webpack DCE 把 const helper globals 去掉,
  // 改用 function declaration 让 helper 名字在函数体内可用
  function safeExtend(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeExtend) {
      console.warn('[ziven-core] safeExtend helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeExtend(targetOrClass, method, fn);
  }
  function safeOverride(targetOrClass, method, fn) {
    if (!window.__zivenCoreSafeOverride) {
      console.warn('[ziven-core] safeOverride helper not loaded, skipped:', method);
      return null;
    }
    return window.__zivenCoreSafeOverride(targetOrClass, method, fn);
  }

  // vendor 2.0: TagSelectionModal 走 flarum-tags bundle 的 addChunkModule 异步注册
  // inline `flarum.reg.get` 拿不到,这里 try-get 优雅降级
  // 1.x 时代 import 路径 'flarum/tags/components/TagSelectionModal' 也是错的,
  //   实际是 'flarum-tags/common/components/TagSelectionModal' (1.8 vendor 验证)
  // 2.0 时代 vendor view 直接把 SelectTagList 放在 Modal-body 内,这个扩展本身就是 no-op
  const TagSelectionModal = typeof flarum !== 'undefined' && flarum.reg && flarum.reg.get ? flarum.reg.get('flarum-tags', 'common/components/TagSelectionModal') : null;
  if (TagSelectionModal) {
    safeExtend(TagSelectionModal, 'oncreate', function () {
      const ModalContent = $(this.element).find(".Modal-content");
      let task = setInterval(function () {
        const SelectTagList = $(ModalContent).find(".SelectTagList");
        if (SelectTagList.length > 0) {
          const ModalBody = $(ModalContent).find(".Modal-body");
          $(SelectTagList).appendTo(ModalBody);
          clearInterval(task);
        }
      }, 100);
    });
  }
  // else: 2.0 时代 flarum-tags 走异步 chunk,inline 拿不到,跳过扩展 (vendor 已把 SelectTagList 放在 Modal-body 内)
};